// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__oHWBs","footer":"ModalFilter_footer__3umt_"};